module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/most2-a9308bb94855c1fbf667d77d102213a7.jpg";